<template>
  <div :class="divWidthChange">
    <fccTitlePage titlePage="Armazenamento" />
    <div class="row">
      <div class="col-12 mx-auto">
        <div id="chart">
          <div class="row mt-5">
            <div class="col-sm-12">
              <span class="titlePage sub">Arquivos por Repositório</span>
              <hr />
              <fccTable
                striped
                hover
                :fields="FieldRepositorio"
                responsive
                :porPage="itemPorPage"
                search
                pagination
                fieldVisibility
                pdf
                csv
                xls
                :titlePage="titlePage"
                :titlePDF="titlePDF"
                :items="excelTotal"
              >
              </fccTable>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-5">
      <div class="col-sm-12">
        <span class="titlePage sub">Arquivos por Tipo</span>
        <hr />
        <fccTable
          striped
          hover
          :fields="fieldsTipo"
          responsive
          :porPage="itemPorPage"
          search
          pagination
          fieldVisibility
          pdf
          csv
          xls
          :titlePage="titlePage"
          :titlePDF="titlePDF"
          :items="excelJson"
        >
        </fccTable>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '@/store'
export default {
  data() {
    return {
      titlePage: 'Gestão Arquivos',
      nameExcel: 'ExcelFcc-' + this.geraNome() + '.xls',
      nameExcelJr: 'ExcelFcc-' + this.geraNome() + '.xls',
      baseUrlSga: '',
      excelJson: [],
      excelTotal: [],
      listarTotal: {
        numbers: [],
        labels: []
      },
      listandoArquivo: {
        numbers: [],
        labels: []
      },
      FieldRepositorio: [
        { key: 'repoid', label: 'Id', sortable: true, active: true },
        { key: 'repodescricao', label: 'Descrição', sortable: true, active: true },
        { key: 'qtde', label: 'Quantidade', sortable: true, active: true, totalizar: true },
        {
          key: 'arqtamanhogb',
          label: 'Espaço utilizado (GB)',
          sortable: true,
          active: true,
          totalizar: true,
          formatter(data) {
            let num = data.replace(',', '.')
            return parseFloat(num).toFixed(5)
          }
        }
      ],
      fieldsTipo: [
        { key: 'arqcadid', label: 'Id', sortable: true, active: true },
        { key: 'repodescricao', label: 'Repositório', sortable: true, active: true },
        { key: 'arqcadcodigo', label: 'Código', sortable: true, active: true },
        { key: 'arqcaddescricao', label: 'Descrição', sortable: true, active: true },
        { key: 'qtde', label: 'Quantidade', sortable: true, active: true, totalizar: true },

        {
          key: 'arqtamanhogb',
          label: 'Espaço utilizado (GB)',
          sortable: true,
          active: true,
          totalizar: true,
          formatter(data) {
            let num = data.replace(',', '.')
            return parseFloat(num).toFixed(5)
          }
        }
      ],
      itemPorPage: '100',
      titlePDF: 'Arquivos por Tipo'
    }
  },
  methods: {
    listarTotalporCadastroArquivo: function () {
      axios
        .get(
          this.baseUrlSga + 'DashBoard/ListaTotalPorCadastroArquivo',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.excelJson = response.data
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    listarTotalporRepositorio: function () {
      this.carregaTexto(this.codeMensagem('C01'))

      axios
        .get(
          this.baseUrlSga + 'DashBoard/ListaTotalPorRepositorio',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.excelTotal = response.data
          this.listarTotalporCadastroArquivo()
        })
        .catch(this.setErrorSystem)
    }
  },
  mounted: function () {
    this.baseUrlSga = store.state.baseUrlSga
    this.listarTotalporRepositorio()
  }
}
</script>
